import { render } from "./ModalExtract.vue?vue&type=template&id=9fb978f4&scoped=true"
import script from "./ModalExtract.vue?vue&type=script&lang=js"
export * from "./ModalExtract.vue?vue&type=script&lang=js"

import "./ModalExtract.vue?vue&type=style&index=0&id=9fb978f4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fb978f4"]])

export default __exports__